import React from 'react';
import { AlertTriangle, PackageX, Pencil, Truck } from 'lucide-react';

// Dashboard warning: parts with 5 or fewer units left
const LowStockAlert = ({ items = [], outCount = 0, onEdit, onViewAll }) => {
  if (!items.length) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-5 mb-8 flex items-center gap-3 text-sm text-gray-600" data-testid="low-stock-ok">
        <span className="w-2.5 h-2.5 rounded-full bg-green-500" /> Stocks OK : aucune pièce à 5 unités ou moins.
      </div>
    );
  }
  return (
    <div className="bg-white rounded-lg shadow-sm border-l-4 border-amber-500 mb-8" data-testid="low-stock-alert">
      <div className="p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <AlertTriangle size={22} className="text-amber-500 flex-shrink-0 mt-0.5" />
          <div>
            <h2 className="font-semibold text-gray-900" data-testid="low-stock-title">
              Stock bas : {items.length} pièce{items.length > 1 ? 's' : ''} à 5 unités ou moins
              {outCount > 0 && <span className="ml-2 text-xs font-medium bg-red-100 text-red-700 px-2 py-0.5 rounded-full" data-testid="low-stock-out-count">{outCount} en rupture</span>}
            </h2>
            <p className="text-sm text-gray-500">Réapprovisionnez ou mettez à jour le stock pour éviter les ventes manquées. Les clients ayant ces pièces en liste de souhaits seront prévenus du retour en stock.</p>
          </div>
        </div>
        <button type="button" data-testid="low-stock-view-products" onClick={onViewAll} className="text-sm text-blue-600 hover:underline whitespace-nowrap">Voir tous les produits</button>
      </div>
      <ul className="divide-y divide-gray-100 border-t border-gray-100" data-testid="low-stock-list">
        {items.slice(0, 8).map(p => (
          <li key={p.id} data-testid={`low-stock-item-${p.id}`} className="flex items-center gap-3 px-5 py-2.5">
            <img src={p.image} alt="" className="w-9 h-9 object-contain bg-gray-50 rounded" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">{p.name} <span className="text-gray-400 font-normal">· {p.brand}</span></p>
              <p className="text-xs text-gray-400 font-mono">Réf. {p.ref}</p>
            </div>
            <span data-testid={`low-stock-qty-${p.id}`} className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full ${p.stock === 0 ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
              {p.stock === 0 ? <><PackageX size={12} /> Rupture</> : `${p.stock} restant${p.stock > 1 ? 's' : ''}`}
            </span>
            {p.supplier_stock > 0 && <span data-testid={`low-stock-supplier-${p.id}`} className="inline-flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full bg-blue-50 text-blue-700" title="Stock disponible chez vos fournisseurs"><Truck size={12} /> +{p.supplier_stock} fournisseur</span>}
            <button type="button" data-testid={`low-stock-edit-${p.id}`} onClick={() => onEdit(p.id)} className="p-1.5 text-blue-600 hover:bg-blue-50 rounded" title="Mettre à jour le stock"><Pencil size={14} /></button>
          </li>
        ))}
        {items.length > 8 && <li className="px-5 py-2 text-xs text-gray-500">+ {items.length - 8} autre{items.length - 8 > 1 ? 's' : ''} — voir l'onglet Produits</li>}
      </ul>
    </div>
  );
};

export default LowStockAlert;
